var _defs, _rect, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _circle, _circle2, _circle3, _circle4, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 164",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dusk-sky",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0c1824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35%",
    stopColor: "#1a2a10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "65%",
    stopColor: "#8a4808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    stopColor: "#c06818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#a05010"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "dusk-sun",
    cx: "38%",
    cy: "68%",
    r: "40%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffcc60",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    stopColor: "#e07820",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0c1824",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ground-e",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0e1a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#060c04"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 164,
    fill: "url(#dusk-sky)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76,
    cy: 112,
    rx: 70,
    ry: 28,
    fill: "url(#dusk-sun)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 120 Q20 108 40 114 Q60 108 80 112 Q100 106 120 110 Q145 104 165 110 Q180 106 200 112 L200 164 L0 164Z",
    fill: "url(#ground-e)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 135 Q50 128 100 132 Q150 126 200 130 L200 164 L0 164Z",
    fill: "#060a04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52 L88 116 L92 116 L92 52 L90 48Z",
    fill: "#2a1808",
    stroke: "#c07818",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85 50 Q90 42 95 50 L92 52 L88 52Z",
    fill: "#3a2010",
    stroke: "#d08820",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72 55 Q90 48 108 55 L104 60 L76 60Z",
    fill: "#4a3020",
    opacity: 0.8,
    stroke: "#c07820",
    strokeWidth: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76 60 L82 68 L70 64Z",
    fill: "#3a2010",
    opacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104 60 L98 68 L110 64Z",
    fill: "#3a2010",
    opacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54 Q82 52 84 55 Q82 58 78 56Z",
    fill: "#e09030",
    opacity: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60 95 L62 115 L66 115 L65 95Z",
    fill: "#1a1008",
    opacity: 0.8
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95 L60 88 L65 90Z",
    fill: "#2a1808",
    opacity: 0.6
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M55 90 Q62 87 68 90 L66 93 L57 93Z",
    fill: "#2a1808",
    opacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M130 88 L132 112 L136 112 L135 88Z",
    fill: "#1a1008",
    opacity: 0.7
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M132 88 L130 82 L136 84Z",
    fill: "#1a0a04",
    opacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128 85 Q133 82 138 85 L136 88 L130 88Z",
    fill: "#1a0a04",
    opacity: 0.4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42 102 L44 118 L47 118 L46 102Z",
    fill: "#141008",
    opacity: 0.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M160 96 L162 116 L165 116 L164 96Z",
    fill: "#141008",
    opacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10 100 Q14 95 12 88 Q15 84 18 88 Q17 95 20 100Z",
    fill: "#0a100a",
    opacity: 0.7
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25 105 Q28 98 26 92 Q29 88 32 92 Q31 99 34 105Z",
    fill: "#0a100a",
    opacity: 0.6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M170 98 Q173 92 171 86 Q174 82 177 86 Q176 93 179 98Z",
    fill: "#0a100a",
    opacity: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M175 102 Q177 97 175 92 Q178 88 181 92 Q180 97 182 102Z",
    fill: "#0a100a",
    opacity: 0.4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M185 96 Q187 91 185 86 Q188 82 191 86 Q190 91 192 96Z",
    fill: "#0a100a",
    opacity: 0.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 72,
    r: 1,
    fill: "#1a2a2a",
    opacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 64,
    r: 0.8,
    fill: "#1a2a2a",
    opacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 60,
    r: 1,
    fill: "#1a2a2a",
    opacity: 0.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 68,
    r: 0.7,
    fill: "#1a2a2a",
    opacity: 0.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 55,
    r: 0.9,
    fill: "#1a2a2a",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.0c1b56701071ae7d515d189b573a80b9.svg";
export { ForwardRef as ReactComponent };